import { t } from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { errorToast } from "../components/widgets/Toastify/Toastify";

export const useTranslatedTitle = (translationKey: string) => {
  const { t, ready } = useTranslation();

  useEffect(() => {
    if (ready) {
      document.title = t(translationKey);
    }
  }, [ready, t, translationKey]);
};

export const handleCurrentlyReading = (
  navigate: ReturnType<typeof useNavigate>
) => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      navigate("/CurrentlyReading", {
        state: {
          prefilledLocation: { lat: latitude, lng: longitude, name: "" },
        },
      });
    },
    (error) => {
      console.error(error);
      errorToast(t("pages.currentlyReading.error.getLocationFailed"));
    }
  );
};

function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomPhotoUrl = () => {
  const n = getRandomInt(
    Number.parseInt(process.env.REACT_APP_PLACEHOLDER_PHOTO_MIN!),
    Number.parseInt(process.env.REACT_APP_PLACEHOLDER_PHOTO_MAX!)
  ).toString();

  return process.env.REACT_APP_PLACEHOLDER_PHOTO_PATH?.replace("{n}", n);
};

export const urlToFile = async (
  url: string,
  filename: string,
  mimeType: string
): Promise<File> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const getCountryFromCoordinates = async (lat: number, lng: number) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
    );
    const data = await response.json();
    return data.address?.country || "Unknown";
  } catch (error) {
    console.error(error);
    return "Unknown";
  }
};
